import React, { useContext, useEffect, useState } from 'react'
import style from './Layout.module.css'
import { Link, Outlet, useLocation } from 'react-router-dom'
import Navbar from '../navbar/Navbar'
import Footer from '../footer/Footer'
import labLogo from '../../assets/images/logo-mekyal-saudi.webp'
import infoLogo from '../../assets/images/Picture1-150x150.webp'
import logos from '../../assets/images/Picsart_25-02-24_14-36-44-480.png'
import { LangContext } from '../context/LangContext'
import i18n from 'i18next'
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { Helmet } from 'react-helmet';
export default function Layout() {

  let {language, setLanguage}= useContext(LangContext)
  const [show, setShow] = useState('')
  const [sitePage, setSitePage] = useState(false)
  const site = sessionStorage.getItem('desiredPage')
  const location = useLocation()

    //selection or site
    useEffect(() => {
      if (site===null) {
        setSitePage(false)
      } else {
        setSitePage(true)
      }
    }, [site])

    //choose language
  const toggleLanguage = () => {
      const newLanguage = language === 'en' ? 'ar' : 'en'
      i18n.changeLanguage(newLanguage)
      setLanguage(newLanguage)
    }
  
    // what page?
    useEffect(() => {
      if (location.pathname === "/select-site") {
        sessionStorage.removeItem('desiredPage')
        setSitePage(false)
      } 
      if (location.pathname === "/comingSoon") {
        setShow(false)
      } else {
        setShow(true)
      }
      
      window.scrollTo(0, 0);
    }, [location])
    
    //prevent copy
      const handleCopy = (event) => {
        event.preventDefault();
        alert("Copying is disabled.");
      };
    
    //prevent cut
      const handleCut = (event) => {
        event.preventDefault();
        alert("Cutting is disabled.");
      }

  return <>
  <Helmet>
    <link rel="icon" href={site === null ? logos : site === 'company' ? infoLogo : labLogo}/>
  </Helmet>
  {!sitePage? '':<FloatingWhatsApp
      phoneNumber={site==='company'? '+966558213234':'+966501533348'} 
      accountName="دعم العملاء" 
      chatMessage="مرحبًا! كيف يمكنني مساعدتك؟ 😊" 
      allowClickAway 
      notification 
      notificationSound
      avatar={site==='company'? infoLogo:labLogo}
    />}
    <div className={`${language === 'en' ? 'roboto-font' : 'cairo-font'} no-select`} onCopy={handleCopy} onCut={handleCut}>
      {!show || !sitePage? '':<Navbar/>}
        <div className={`position-fixed ${style.zhightest} ${language === 'en' ? 'cairo-font fw-bold end-0 align-items-end' : 'roboto-font fw-semibold'} d-flex flex-column justify-content-center ${site===null? (style.top30vh):`top-0 ${style.bottom44vh}`}`}>
          {site===null? '':<Link to={'/select-site'} className={`py-1 px-2 ${style.bgLang} ${language==='en'? (style.choosenEn):style.choosenAr} trans3 text-white cursor-pointer w-fit`}>
            <i className={`fa-solid fa-right-from-bracket fs-5 ${language==='en'? '': style.flip}`}></i>
          </Link>}
          {site===null? '':<Link to={'/'} className={`py-1 px-2 ${style.bgLang} ${language==='en'? (style.choosenEn):style.choosenAr} trans3 text-white mt-5 mb-3 cursor-pointer w-fit`}>
            <i className='fa-solid fa-house'></i>
          </Link>}
          <span onClick={toggleLanguage} className={`py-1 px-2 ${style.bgLang} ${language==='en'? (style.choosenEn):style.choosenAr} trans3 text-white cursor-pointer w-fit`}>
            {language === 'en' ? 'عر' : 'En'}
          </span>
        </div>
        <div className={`position-relative ${site===null? 'h-91 flex-column d-flex justify-content-between': !show? '':' mt-5rem'}`}>
          <Outlet></Outlet>
        </div>
        {!show || !sitePage? 
            '':<Footer/>}
        {/* {isVisible? <button onClick={scrollToTop} className={`btn bg-main2 rounded-circle position-fixed d-flex align-items-center cursor-pointer ${style.zhightest} ${style.toTopPostion} justify-content-center p-2`}>
          <i className="fa-solid fa-chevron-up fs-5 text-white"></i>
        </button>:''} */}
    </div>
  </>
}
